// segment event schemas
export const SEGMENT_EVENTS_SCHEMA_PREFIX = `https://${process.env.NEXT_PUBLIC_HOST_NAME}/assets/measure/schemas/digital-product/dotcom/platform/web/classification`;
export const PAGE_EVENT_CART_VIEWED_SCHEMA =
  '/core-buy-flow/experience/cart/event-type/page/event-name/cart-viewed/version/LATEST/schema.json';
export const TRACK_EVENT_CART_VIEWED_SCHEMA =
  '/core-buy-flow/experience/cart/event-type/track/event-name/cart-viewed/version/LATEST/schema.json';
export const TRACK_EVENT_PRODUCT_ADDED_SCHEMA =
  '/core-buy-flow/experience/cart/event-type/track/event-name/product-added/version/LATEST/schema.json';
export const TRACK_EVENT_PRODUCT_REMOVED_SCHEMA =
  '/core-buy-flow/experience/cart/event-type/track/event-name/product-removed/version/LATEST/schema.json';
export const TRACK_EVENT_WISHLIST_PRODUCT_ADDED_SCHEMA =
  '/core-buy-flow/experience/wishlist/event-type/track/event-name/product-added/version/LATEST/schema.json';
